/**
 * The SpecLens API, as the browser sees it. One route: the browser reads the PDFs itself and
 * sends only the text of the pages worth analysing, so there is no upload, no stored result
 * and no decision log on the server. Reuses api.ts's BASE/postJson/ApiError.
 */

import type { AnalysisResult, AnalyzeRequest, LearnedManufacturer, NameVerdict } from "@plan-forge/speclens-contract";
import { BASE, json, postJson, type AuthHeaders } from "./api.ts";

const NO_AUTH: AuthHeaders = async () => ({});

export async function analyzeSpeclens(request: AnalyzeRequest, auth: AuthHeaders = NO_AUTH): Promise<AnalysisResult> {
  return postJson<AnalysisResult>("/speclens/analyze", request, auth);
}

/** Approve or reject a maker the spec named; approved makers are read as manufacturers in every project. */
export async function judgeManufacturer(name: string, verdict: NameVerdict, auth: AuthHeaders = NO_AUTH): Promise<LearnedManufacturer> {
  return postJson<LearnedManufacturer>("/speclens/names", { name, verdict }, auth);
}

/** The makers reviewers have approved or rejected. */
export async function listManufacturers(auth: AuthHeaders = NO_AUTH): Promise<readonly LearnedManufacturer[]> {
  const body = await json<{ names: readonly LearnedManufacturer[] }>(await fetch(`${BASE}/speclens/names`, { headers: await auth() }));
  return body.names;
}
